document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".bs-video-strategico__frame");
  const overlay = document.getElementById("bsVideoOverlay");
  const closeBtn = document.querySelector(".bs-video-overlay__close");
  const iframe = document.getElementById("bsVideoIframe");

  if (trigger && overlay && iframe) {
    const url = trigger.getAttribute("data-video-url") + "?autoplay=1";

    trigger.addEventListener("click", () => {
      overlay.removeAttribute("hidden");
      iframe.src = url;
    });

    closeBtn.addEventListener("click", () => {
      overlay.setAttribute("hidden", true);
      iframe.src = ""; // stop playback
    });
  }
});
